export default __webpack_public_path__ + "9ae97e8e97e0555ccb7f3dfe94dbf1d2.png";